// Central SEO config. Production canonical domain.
export const SITE_URL = "https://airporttransfer24.ch";
export const BRAND = "Airport Transfer Zurich";
export const PHONE = "+41 79 177 24 24";

export const abs = (path = "") => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

// Shared Organization / LocalBusiness node reused across pages.
export const orgSchema = () => ({
  "@context": "https://schema.org",
  "@type": "TaxiService",
  name: BRAND,
  image: `${SITE_URL}/airport-transfer-24-logo.png`,
  url: SITE_URL,
  telephone: "+41791772424",
  priceRange: "$$",
  areaServed: [
    { "@type": "Country", name: "Switzerland" },
    { "@type": "Country", name: "Germany" },
    { "@type": "Country", name: "France" },
    { "@type": "Country", name: "Italy" },
    { "@type": "Country", name: "Austria" },
    { "@type": "Country", name: "Liechtenstein" },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Flughafenstrasse 1",
    postalCode: "8302",
    addressLocality: "Kloten",
    addressRegion: "ZH",
    addressCountry: "CH",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.8",
    reviewCount: "250",
    bestRating: "5",
  },
});

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: abs(it.path),
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
